import Vue from 'vue'
import VueRouter from 'vue-router'

import {
  increaseVisitIntro,
  increaseVisitHome
} from '../firebase/firebase-transaction.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        beforeEnter: async (to, from, next) => {
          await increaseVisitIntro()
          next()
        }
      },
      {
        path: 'project',
        name: 'project',
        component: () => import('../views/PropertyPage.vue'),
        beforeEnter: async (to, from, next) => {
          await increaseVisitHome()
          next()
        }
      },
      {
        path: 'newInvest',
        name: 'NewInvest',
        component: () => import('../views/NewInvestPage.vue'),
        params: true
      },
      {
        path: 'joinInvest',
        name: 'JoinInvest',
        component: () => import('@/views/JoinInvestPage.vue'),
        params: true
      },
      {
        path: 'FAQ',
        name: 'FAQ',
        component: () => import('@/views/FAQPage.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: 'about' */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})

export default router